export default __webpack_public_path__ + "static/AD_8860_rgb-6cecc9acca5f2dff2c30171d87146e0f.jpg";